import React, { PropTypes } from 'react'
import TopUserMenu from '../TopUserMenu'
import './header.scss';
import {Link} from 'react-router'
import { connect } from 'react-redux'

class Header extends React.Component {
//<img src="/assets/logo.png" width='100%' alt=""/>
  render() {
    console.log(this.props)
    return (
      <header className="header">

          <Link className='logo' to='/jobs'>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </Link>


        <div className="pull-left">

          { this.props.job && this.props.job.label && this.props.params && this.props.params.sheet &&
            <div className="hidden job-pod">
              <div className="head">
                <div className='row'>
                    <div className='col-xs-8'>
                      {this.props.job.label} <span className="badge hidden">NEW</span>
                      <h3 className='m-0'><small>{this.props.job.start}</small></h3>
                    </div>
                    <div className='col-xs-4 text-right'>
                      £{this.props.job.total && (Number(this.props.job.total.sale)-Number(this.props.job.total.cost))}<br/>
                    </div>
                </div>
              </div>
            </div>
          }

          { !this.props.params.sheet &&
            <h1 className='logo-name'><strong>Pro</strong>Quotes</h1>
          }

          { this.props.job && this.props.job.label && this.props.params && this.props.params.sheet &&
            <h1>{this.props.job.label} <small>Start: {this.props.job.start}</small></h1>
          }

          <TopUserMenu user_facebook={this.props.user_facebook} signOut={this.props.signOut}></TopUserMenu>

        </div>
      </header>
    );
  }
}

function mapStateToProps (state, ownProps) {
  return {
    job: state.finance.job
  }
}

export default connect(mapStateToProps)(Header)



// WEBPACK FOOTER //
// ./src/views/components/Header/index.js